<angular-editor
  [(ngModel)]="htmlContent"
  [config]="editorDefaultConfig"
  (ngModelChange)="onChangeEvent()"
></angular-editor>
